module.exports = __webpack_public_path__ + "media/images/country_flags/ng-67ca2621cda9c243a49aaf52d527fd17.png";